"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartFooter = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("../../styles");
var Text_1 = require("../Text");
function ChartFooter(props) {
    var children = props.children;
    var classes = styles_1.useStyles(createStyles).classes;
    return (react_1.default.createElement(Text_1.Text, { className: classes.footer, component: 'span', fontSize: 0.8 }, children));
}
exports.ChartFooter = ChartFooter;
var createStyles = function () { return ({
    footer: {
        padding: '0 1.5rem 1.5rem 1.5rem',
        display: 'inline-block',
        width: '100%',
    },
}); };
//# sourceMappingURL=ChartFooter.js.map